
import { motion } from "framer-motion";

const RecipeHeader = () => {
  return (
    <div className="text-center mb-12">
      <motion.h1 
        className="text-4xl font-light mb-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.8 }}
      >
        Authentic Fortune Cookie Recipe
      </motion.h1>
      <motion.p
        className="text-muted-foreground text-lg"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4, duration: 0.8 }}
      >
        Create restaurant-quality fortune cookies in your own kitchen
      </motion.p>
    </div>
  );
};

export default RecipeHeader;
